/** Demo rows. Not an API payload — see `types/user-types` for that. */
type DemoUserRow = {
  id: string;
  value: string;
  avatar: string;
  name: string;
  firstName?: string;
  lastName?: string;
  role: string;
  active: boolean;
  email: string;
  phone: string;
  lastLogin: string;
  provider_group_location: string;
};

const UserData: DemoUserRow[] = [
  {
    id: "101",
    value: "ryan",
    avatar: "/src/assets/dashBoard/user-settingsProfileImages/RyanWeste.png",
    name: "Ryan Weste",
    firstName: "Ryan",
    lastName: "Weste",
    role: "billing_staff",
    active: false,
    email: "Ryanweste@gmail.com",
    phone: "+224576858198",
    lastLogin: "20 Dec 2022 02:25 PM",
    provider_group_location: "alex_core",
  },
  {
    id: "102",
    value: "ricardo",
    avatar:
      "/src/assets/dashBoard/user-settingsProfileImages/RicardoHoffman.png",
    name: "Ricardo Hoffman",
    firstName: "Ricardo",
    lastLogin: "Hoffman",
    role: "physician_assistant",
    active: true,
    email: "Ricardohoffman@gmail.com",
    phone: "+224576858198",
    lastName: "20 Dec 2022 02:25 PM",
    provider_group_location: "alex_core",
  },
  {
    id: "103",
    value: "grady",
    avatar: "/src/assets/dashBoard/user-settingsProfileImages/GradyHammond.png",
    name: "Grady Hammond",
    firstName: "Grady",
    lastName: "Hammond",
    role: "physician",
    active: true,
    email: "Gradyhammond@gmail.com",
    phone: "+224576858198",
    lastLogin: "20 Dec 2022 02:25 PM",
    provider_group_location: "location1",
  },
  {
    id: "104",
    value: "eduardo",
    avatar:
      "/src/assets/dashBoard/user-settingsProfileImages/AlisonBuchanan.png",
    name: "Eduardo Mcguire",
    firstName: "Eduardo",
    lastName: "Mcguire",
    role: "billing_staff",
    active: false,
    email: "Eduardomcguire@gmail.com",
    phone: "+224576858198",
    lastLogin: "20 Dec 2022 02:25 PM",
    provider_group_location: "location1",
  },
  {
    id: "105",
    value: "alison",
    avatar:
      "/src/assets/dashBoard/user-settingsProfileImages/EduardoMcguire.png",
    name: "Alison Buchanan",
    firstName: "Alison",
    lastName: "Buchanan",
    role: "physician",
    active: true,
    email: "Alisonbuchanan@gmail.com",
    phone: "+224576858198",
    lastLogin: "20 Dec 2022 02:25 PM",
    provider_group_location: "location1",
  },
  {
    id: "106",
    value: "adrienne",
    avatar:
      "/src/assets/dashBoard/user-settingsProfileImages/AdrienneWarner.png",
    name: "Adrienne Warner",
    firstName: "Adrienne",
    lastName: "Warner",
    role: "physician_assistant",
    active: true,
    email: "adriennewarner@gmail.com",
    phone: "+224576858198",
    lastLogin: "20 Dec 2022 02:25 PM",
    provider_group_location: "location1",
  },
  {
    id: "107",
    value: "jacquelyn",
    avatar:
      "/src/assets/dashBoard/user-settingsProfileImages/JacquelynAndrews.png",
    name: "Jacquelyn Andrews",
    firstName: "Jacquelyn",
    lastName: "Andrews",
    role: "billing_staff",
    active: false,
    email: "Jacquelynandrews@gmail.com",
    phone: "+224576858198",
    lastLogin: "20 Dec 2022 02:25 PM",
    provider_group_location: "location1",
  },
  {
    id: "108",
    value: "bessie",
    avatar:
      "/src/assets/dashBoard/user-settingsProfileImages/JacquelynAndrews.png",
    name: "Bessie Patrick",
    firstName: "Bessie",
    lastName: "Patrick",
    role: "facility_admin",
    active: false,
    email: "Bessiepatrick@gmail.com",
    phone: "+224576858198",
    lastLogin: "20 Dec 2022 02:25 PM",
    provider_group_location: "location1",
  },
  {
    id: "109",
    value: "noah",
    avatar: "/src/assets/dashBoard/user-settingsProfileImages/NoahJennings.png",
    name: "Noah Jennings",
    firstName: "Noah",
    lastName: "Jennings",
    role: "facility_admin",
    active: false,
    email: "Noahjennings@gmail.com",
    phone: "+224576858198",
    lastLogin: "20 Dec 2022 02:25 PM",
    provider_group_location: "location1",
  },
  {
    id: "110",
    value: "alex",
    avatar: "/src/assets/dashBoard/user-settingsProfileImages/NoahJennings.png",
    name: "Alex Costa",
    firstName: "Alex",
    lastName: "Costa",
    role: "facility_admin",
    active: true,
    email: "alexcosta@gmail.com",
    phone: "+224576858198",
    lastLogin: "20 Dec 2022 02:25 PM",
    provider_group_location: "location1",
  },
  {
    id: "111",
    value: "bruise",
    avatar: "/src/assets/dashBoard/user-settingsProfileImages/NoahJennings.png",
    name: "Bruise Lee",
    firstName: "Bruise",
    lastName: "Lee",
    role: "facility_admin",
    active: true,
    email: "bruiselee@gmail.com",
    phone: "+224576858198",
    lastLogin: "20 Dec 2022 02:25 PM",
    provider_group_location: "location1",
  },
  {
    id: "112",
    value: "kristen",
    avatar:
      "/src/assets/dashBoard/user-settingsProfileImages/JacquelynAndrews.png",
    name: "Kristen Stewart",
    firstName: "Kristen",
    lastName: "Stewart",
    role: "facility_admin",
    active: true,
    email: "kristenstewart@gmail.com",
    phone: "+224576858198",
    lastLogin: "20 Dec 2022 02:25 PM",
    provider_group_location: "location1",
  },
  {
    id: "113",
    value: "ben",
    avatar: "/src/assets/dashBoard/user-settingsProfileImages/GradyHammond.png",
    name: "Ben Tennyson",
    firstName: "Ben",
    lastName: "Tennyson",
    role: "facility_admin",
    active: true,
    email: "bentenny@gmail.com",
    phone: "+224576858198",
    lastLogin: "20 Dec 2022 02:25 PM",
    provider_group_location: "location1",
  },
  {
    id: "114",
    value: "cristiano",
    avatar:
      "/src/assets/dashBoard/user-settingsProfileImages/RicardoHoffman.png",
    name: "Cristiano Ronaldo",
    firstName: "Cristiano",
    lastName: "Ronaldo",
    role: "Billing Staff",
    active: true,
    email: "crisronaldo@gmail.com",
    phone: "+224576858198",
    lastLogin: "20 Dec 2022 02:25 PM",
    provider_group_location: "location1",
  },
  {
    id: "115",
    value: "will",
    avatar: "/src/assets/dashBoard/user-settingsProfileImages/GradyHammond.png",
    name: "Will Smith",
    firstName: "Will",
    lastName: "Smith",
    role: "Physician",
    active: true,
    email: "willsmith@gmail.com",
    phone: "+224576858198",
    lastLogin: "20 Dec 2022 02:25 PM",
    provider_group_location: "location1",
  },
  {
    id: "116",
    value: "james",
    avatar:
      "/src/assets/dashBoard/user-settingsProfileImages/RicardoHoffman.png",
    name: "James Mathew",
    firstName: "James",
    lastName: "Mathew",
    role: "Billing Staff",
    active: true,
    email: "jamesmathew@gmail.com",
    phone: "+224576858198",
    lastLogin: "20 Dec 2022 02:25 PM",
    provider_group_location: "location1",
  },
  {
    id: "117",
    value: "stephanie",
    avatar:
      "/src/assets/dashBoard/user-settingsProfileImages/JacquelynAndrews.png",
    name: "Stephanie Rice",
    firstName: "Stephanie",
    lastName: "Rice",
    role: "facility_admin",
    active: true,
    email: "stephanier@gmail.com",
    phone: "+224576858198",
    lastLogin: "20 Dec 2022 02:25 PM",
    provider_group_location: "location1",
  },
];

export default UserData;
